
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":"271","height":"271","viewBox":"0 0 271.6 271.2","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0v68.3c112 .2 202.9 90.9 203.3 202.9h68.3C271.2 121.5 149.8.2 0 0z","fill":"#fff"}})])
          )
        }
      }
    